import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Check } from 'lucide-react';
export function Benefits() {
  const benefits = ['Sentir menos rigidez', 'Recuperar estabilidad', 'Volver a caminar con más confianza', "Manejar mejor escaleras (sin 'castigo')"];
  return <Section background="warm" data-id="element-18">
      <FadeIn data-id="element-19">
        <div className="max-w-2xl mx-auto" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-21">
            Qué vas a lograr (sin humo)
          </h2>

          <p className="text-lg text-center mb-10 text-gray-700" data-id="element-22">
            Con una rutina de 10–12 minutos por día, en casa, vas a trabajar
            para:
          </p>

          <div className="mb-10 rounded-2xl overflow-hidden shadow-lg" data-id="element-23">
            <img src="https://cdn.magicpatterns.com/uploads/mV6SBadETEJ1ZSXcdpEST9/heylloyd-image-1770617158616.png" alt="10 minutos en casa — plan de 14 días" className="w-full h-auto object-cover" data-id="element-24" />
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 mb-10" data-id="element-25">
            <ul className="space-y-6" data-id="element-26">
              {benefits.map((benefit, index) => <li key={index} className="flex items-center" data-id="element-27">
                  <div className="flex-shrink-0 h-8 w-8 rounded-full bg-[#D8F3DC] flex items-center justify-center mr-4" data-id="element-28">
                    <Check className="h-5 w-5 text-[#1B4332]" data-id="element-29" />
                  </div>
                  <span className="text-lg font-medium text-[#1A1A1A]" data-id="element-30">
                    {benefit}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="text-center" data-id="element-31">
            <p className="text-xl font-serif italic text-[#1B4332] mb-8" data-id="element-32">
              "No te prometo milagros. Te doy un plan que podés ejecutar incluso
              cuando el día viene torcido."
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
}